import { Component } from "react";
import "./ErrorBoundary.css";

interface ErrorBoundaryState {
  hasError: boolean;
  errorDetails: string;
}

class ErrorBoundary extends Component<{}, ErrorBoundaryState> {
  constructor(props: {}) {
    super(props);
    this.state = { hasError: false, errorDetails: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorDetails: error.message };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error);
    console.log(errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ErrorBoundary">
          <h1>
            {this.state.errorDetails === "Your session has ended" ? "Your session has ended" : "something went wrong"}
          </h1>
          <button
            className="error-boundary-refresh-btn"
            onClick={() => {
              window.location.reload();
            }}
          >
            please try to refresh the page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
